import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appAllGetHubs } from '../../store/hubs'
import { appGetAllSanstha } from '../../store/sanstha'
import { appAllGetFundrasing } from '../../store/fundrasing'
import ReceiptPDF from '../../components/filegenerate/filegenerate'
import PostPreview from '../../components/PostPreview/PostPreview'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	// const navigate = useNavigate();

	const [page, setPage] = useState(params.page || 1)
	const paginate = useSelector(state => state.fundrasingReducer.paginate)
	const isloder = useSelector(state => state?.fundrasingReducer.isloder)
	const fundrasing = useSelector(state => state?.fundrasingReducer.fundrasing)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	useEffect(() => {
		dispatch(
			appAllGetFundrasing({
				page: 1,
				limit: 10,
				paidtoportal: true,
				// sanstha: sansthaId || permissionOfSanstha,
			}),
		)
	}, [])

	useEffect(() => {
		setExportFilters({ paidtoportal: true })
	}, [])

	return (
		<>
			{isloder && <PageLoader />}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Member</th>
									<th>Contribution Type</th>
									<th>Online/Offline</th>
									<th>Amount</th>
									<th>Payment Date</th>
									<th>Action</th>

									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							{fundrasing?.data &&
								fundrasing?.data.map((value, index) => {
									return (
										<tbody key={index}>
											<tr>
												<td>
													<PostPreview value={value?.userId?.profilePic || '/img/user.jpg'} />
													{value.userId.firstName} {value.userId.lastName}
													<br />
													<small>{value.userId.mobile}</small>
												</td>
												<td>
													<br />
													{value.fundraisingType}
												</td>
												<td>
													{value.isOnline}
													{value?.isOnline === true ? (
														<span className="badge badge-primary">Online</span>
													) : (
														<span className="badge badge-primary">Offline</span>
													)}
												</td>
												<td>
													₹<span style={{ fontWeight: 'bold' }}>{value.amount}</span> <br />
													{value?.offlinePaymentMode && (
														<small>Mode: {value?.offlinePaymentMode}</small>
													)}
												</td>
												<td>
													{new Date(value?.updatedAt).toLocaleDateString('en-US', {
														year: 'numeric',
														month: 'short',
														day: 'numeric',
													})}
												</td>
												<td>
													<ReceiptPDF data={value?._id} />
												</td>
											</tr>
										</tbody>
									)
								})}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
